<div class="container result-container">
    <div class="result-data container mt-50">
        <div class="infotmation-container d-flex justify-content-start flex-column">
          <h1 class="text-start" [class.api-message]="mensagemDaApi">
            {{ mensagem }}
          </h1>
          <p class="info-text">
            Informamos que não é possível dar andamento à sua solicitação.
          </p>
          <div class="contact d-flex row gap-2 align-items-center">
          <img src="assets/images/icons/fi_phone.svg" alt="phone icon">
            <p>Central de Atendimento: <strong>0800 012 7173</strong> (exceto para DDD 11) e <strong>11 3065-3000</strong></p>
          </div>
          <div class="contact d-flex row gap-2 align-items-center">
          <img src="assets/images/icons/fi_mail.svg" alt="phone icon">
            <p>E-mail: <strong>atendimento@vivest.com.br</strong></p>
          </div>
        </div>
    </div>
</div>
